<template>
  <div class="md-layout md-gutter">
    <div class="md-layout-item md-size-100 md-small-size-100">
      <div class="md-layout-item md-size-100">
        <DownloadCard/>
      </div>
    </div>
  </div>
</template>

<script>
import DownloadCard from "@/pages/Dashboard/Reports/Downloads/Form/DownloadsCard.vue";

export default {
  name: "Downloads",
  components: {
    DownloadCard,
  }
}
</script>
